// extracted by mini-css-extract-plugin
module.exports = {"links":"LinkGroup_links__HHCng","type--main":"LinkGroup_type--main__QYJ0H","type--sub":"LinkGroup_type--sub__d5VLD","space":"LinkGroup_space__LItWf"};